import http from "@/utils/http";

// 获取角色
export function getRole() {
  return http({
    url: "/admin/roles",
    method: "GET"
  });
}

// 获取权限列表
export function getPowerList(data) {
  return http({
    url: "/admin/auths" + data,
    method: "GET"
  });
}

// 增加权限
export function addPower(data) {
  return http({
    url: "/admin/auth/add",
    method: "POST",
    data
  });
}

// 删除权限
export function delPower(data) {
  return http({
    url: "/admin/auth/delete/" + data,
    method: "POST"
  });
}

// 编辑权限
export function editPower(id, data) {
  return http({
    url: "/admin/auth/update/" + id,
    method: "POST",
    data
  });
}

// 根据角色获取权限
export function getRoleList(data) {
  return http({
    url: "/admin/role/auths?roleid=" + data,
    method: "GET"
  });
}

// 修改权限
export function editRole(id, data) {
  return http({
    url: "/admin/role/auths/update/" + id,
    method: "POST",
    data
  });
}
